import { SSList, SSubtitle, SText } from './ContactDeleteModal.styled'
import { ListItem } from 'components/ListItems'
import { getReadableString } from 'utils/general'
import { useWindowSize } from 'utils/hooks'
import { ApiType } from 'utils/types'

export function ContactDeleteModalContent({
  contact,
}: {
  contact?: ApiType['TrustedContactResponse']
}) {
  const { isDesktop } = useWindowSize()
  const noOfItemsToList = isDesktop ? 9 : 4
  const documentCount = contact?.documents?.length || 0
  const siteCount = contact?.sites?.length || 0
  const deviceCount = contact?.devices?.length || 0
  const directiveCount = contact?.directives?.length || 0
  const orderCount = contact?.orders?.length || 0
  const willCauseLoss = documentCount || siteCount || deviceCount || directiveCount || orderCount
  const MoreText = ({ no }: { no: number }) =>
    no > noOfItemsToList ? (
      <ListItem singleLine text={`...and ${no - noOfItemsToList} more.`} />
    ) : null
  return willCauseLoss ? (
    <>
      <SText>You will lose access to the following data:</SText>
      {documentCount ? (
        <>
          <SSubtitle>Documents and Notes</SSubtitle>
          <SSList>
            {contact?.documents?.slice(0, noOfItemsToList).map((doc, docIndex) => (
              <ListItem singleLine text={doc.title || `Document #${doc.uuid}`} key={docIndex} />
            ))}
            <MoreText no={documentCount} />
          </SSList>
        </>
      ) : null}
      {contact?.sites?.length ? (
        <>
          <SSubtitle>Sites &amp; Accounts</SSubtitle>
          <SSList>
            {contact.sites.slice(0, noOfItemsToList).map((site, siteIndex) => (
              <ListItem singleLine text={site.name || `Site #${site.uuid}`} key={siteIndex} />
            ))}
            <MoreText no={siteCount} />
          </SSList>
        </>
      ) : null}
      {contact?.devices?.length ? (
        <>
          <SSubtitle>Devices</SSubtitle>
          <SSList>
            {contact.devices.slice(0, noOfItemsToList).map((device, deviceIndex) => (
              <ListItem
                singleLine
                text={device.name || `Device #${device.uuid}`}
                key={deviceIndex}
              />
            ))}
            <MoreText no={deviceCount} />
          </SSList>
        </>
      ) : null}
      {contact?.directives?.length ? (
        <>
          <SSubtitle>Directives</SSubtitle>
          <SSList>
            {contact.directives.slice(0, noOfItemsToList).map((directive, i) => (
              <ListItem
                singleLine
                text={getReadableString(directive.directive_type) || `Directive #${directive.uuid}`}
                key={i}
              />
            ))}
            <MoreText no={directiveCount} />
          </SSList>
        </>
      ) : null}
      {contact?.orders?.length ? (
        <>
          <SSubtitle>Orders</SSubtitle>
          <SSList>
            {contact.orders.slice(0, noOfItemsToList).map((order, i) => (
              <ListItem singleLine text={`Order #${order.uuid}`} key={i} />
            ))}
            <MoreText no={orderCount} />
          </SSList>
        </>
      ) : null}
    </>
  ) : null
}
